import React from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface TimeWarningModalProps {
  isVisible: boolean;
  onClose: () => void;
  remainingSeconds: number;
}

const TimeWarningModal: React.FC<TimeWarningModalProps> = ({ isVisible, onClose, remainingSeconds }) => {
  const { t } = useTranslation("settings");
  
  if (!isVisible) return null;

  // Format seconds to MM:SS
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="time-warning-modal-container">
      <div className="time-warning-modal">
        <div className="time-warning-header">
          <div className="warning-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L2 20h20L12 2zm0 5v6m0 4h.01"
                stroke="#856404"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="time-warning-content">
            <h3 className="time-warning-title">{t("instantMeet.timeWarning.title")}</h3>
            <p className="time-warning-text">
              {t("instantMeet.timeWarning.message")}
              <br />
              {t("instantMeet.timeWarning.wrapUp")}
            </p>
            <div className="remaining-time">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <span>
                {t("instantMeet.timeWarning.remainingTime")} <strong>{formatTime(remainingSeconds)}</strong>
              </span>
            </div>
          </div>
          <button className="time-warning-ok-btn" onClick={onClose}>
            {t("instantMeet.timeWarning.okButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeWarningModal;
